<template>
  <div class="solution-tim">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionTim"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : (index == indexActive)}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor(('#anchor-' + index ), index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro">
        <div class="content">
          腾讯云智媒体AI中台，为传媒行业量身打造：集合顶尖AI能力和深刻的业务理解，提供智能化、全流程、一站式的视频结构化、视频处理、质量检测、视频审核等AI应用；全面优化媒资生产、管理、消费环节，助力AI能力到业务场景落地的“最后一公里”。
        </div>
      </div>
      <div class="core-competence">
        <div class="core-competence-item"
          :class="{'core-even': (index % 3 !== 2), 'last-core' : (index == (introTim.length - 1))}"
          :style="{backgroundImage:'url(' + item.imgUrl + ')',backgroundSize:'contain' }"
          v-for="(item, index) in introTim"
          :key="index">
          <div class="core-img" ></div>
          <div class="core-title">
            {{item.title}}
          </div>
          <div class="core-content">
            {{item.content}}
          </div>
        </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionTim"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionTim"></application-scene>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import applicationConstant from './data/ApplicationConstant';
import advantageConstant from './data/AdvantageConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

const introTim = [
  {
    title: '智能标签',
    content: '全维度分析视频的音频、文本和画面的各模态信息，并通过优图领先的图像处理、自然语言处理、多模态融合算法的多项AI算法能力，对视频中出现的内容信息和视频中讲述的内容进行全方位标签提取，精准地输出覆盖文本、图像、人脸的全维度标签，支持业务全场景使用。',
    imgUrl: require('./img/intro/tim_intro_01.png')
  }, {
    title: '智能拆条',
    content: '对完整的视频内容进行“音视图文”多维度结构化分析，生成的片段及对应信息可直接入库存储和内容分发，在提高拆条效率的同时，丰富拆条结果的细粒度，提高内容搜索、定位、获取的效率，兼容互联网标签体系，为内容运营、多模态搜索提供数据基础。',
    imgUrl: require('./img/intro/tim_intro_02.png')
  }, {
    title: '智能编目',
    content: '基于广电媒体资产系统，按照广电编目标准的叙述方式，通过智能化手段，实现“音视图文”多维度编目，补足原有广电编目数据，为台内提供丰富内容结构化数据提高搜索、定位、获取效率，兼容互联网标签体系为融媒体内容运营、多模态搜索提供数据基础。',
    imgUrl: require('./img/intro/tim_intro_03.png')
  }, {
    title: '人脸集锦',
    content: '视频场景专属优化的人脸识别能力，支持视频素材的人脸识别和人脸出现段落定位。',
    imgUrl: require('./img/intro/tim_intro_04.png')
  }, {
    title: '视频质检',
    content: '运用多维度AI质量检测能力，深度检测视频融质量问题，快速发现并定位问题，助力媒体轻松应对视频素材激增导致的巨量质检工作。',
    imgUrl: require('./img/intro/tim_intro_05.png')
  }, {
    title: '视频处理',
    content: '一站式视频处理方案，全面修复视频生产、传输和消费环节因视频储存、画面、码率、帧数、带宽等因素引起的视频质量缺陷，优化视频呈现质量。该功能由腾讯多媒体实验室提供。',
    imgUrl: require('./img/intro/tim_intro_06.png')
  }, {
    title: '视频审核',
    content: '运用多维度AI能力，结合腾讯21年黑产攻防经验，深度贴合媒体业务，辅助人工进行全维度，全流程的内容风险管理，助力业务快速健康发展。该功能由腾讯优图与腾讯天御团队共同提供。',
    imgUrl: require('./img/intro/tim_intro_07.png')
  }
];

export default {
  name: 'tim',
  components: {
    SolutionBanner,
    ApplicationScene,
    SchemeAdvantage
  },
  data() {
    return {
      bannerConstant,
      AnchorsItems: ['方案介绍', '方案优势', '应用场景'],
      advantageConstant,
      applicationConstant,
      introTim,
      secondNavFixed: false,
      indexActive: 0
    };
  },
  methods: {
    downloadExcel(url, newPage) {
      if (newPage) {
        window.open(url, '_blank');
        return;
      }
      window.open(url, '_self');
    },
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    },
    handleGoDetailPage(url) {
      this.$router.transfer(url);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-tim {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    &.client-case{
      background-color: rgb(245, 246, 247);
      padding-bottom: 100px;
    }
  }
  .video-understanding-img-intro {
    .video-understanding {
      width: 1170px;
      height: 690px;
      margin: 0 auto;
      background: url(./img/safe/app_bak.jpg) no-repeat;
    }
  }
  .solution-title{
    padding-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro{
    width: 1170px;
    margin: 0 auto;
    .content{
      font-size: 16px;
      color: #212121;
      line-height: 1.8;
      text-align: justify;
      margin-bottom: 26px;
    }
  }
  .core-competence{
    width: 1170px;
    margin: 0 auto;
    overflow: hidden;
    font-size: 0;
    .core-competence-item{
      vertical-align: top;
      width: 380px;
      min-height: 490px;
      margin-bottom: 30px;
      padding: 280px 20px 30px 20px;
      display: inline-block;
      background-repeat: no-repeat;
      border: #e6e6e6 1px solid;
      color: #242526;
      &.core-even{
        margin-right: 15px;
      }
      &.last-core{
        margin-bottom: 0;
      }
      .core-title{
        font-size: 24px;
        line-height: 1.0;
        text-align: center;
      }
      .core-content{
        line-height: 1.8;
        font-size: 16px;
        text-align: justify;
        margin-top: 36px;
      }
    }
  }
  .auditing-img-intro{
    width: 1170px;
    height: 820px;
    margin: 58px auto 0;
    font-size: 0;
    text-align: center;
    .auditing-plat-item{
      position: relative;
      vertical-align: top;
      width: 380px;
      height: 410px;
      border: #e6e6e6 1px solid;
      margin: 0 0 10px 10px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center 0;
      color: #242526;
      &.no-margin-right{
        margin-right: 0;
      }
      .intro-title {
        font-size: 22px;
        line-height: 1.0;
        margin-top: 206px;
        text-align: center;
      }
      .intro-info {
        font-size: 16px;
        line-height: 1.8;
        text-align: justify;
        color: #212121;
        padding: 20px ;
      }
    }
  }
  .client-case-auditing{
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0;
    .case-info, .case-img{
      display: inline-block;
      height: 340px;
      width: 585px;
      vertical-align: top;
    }
    .case-img{
      background-image: url('./img/case/you_safe_pic5.jpg');
    }
    .case-info {
      padding: 58px 36px;
      background: #ffffff;
      line-height: 40px;
      border: #f0f0f0 1px solid;
      border-right: none;
      .auditing-title{
        line-height: 40px;
        font-size: 26px;
        padding-left: 138px;
        background-image: url(./img/case/case_logo_redbook.png);
        background-repeat: no-repeat;
        background-position: 0 center;
      }
      .auditing-content {
        margin-top: 28px;
        font-size: 16px;
        width: 510px;
        text-align: justify;
        line-height: 1.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionTim.vue